import axios from 'axios'
import qs from 'qs'
import Vue from 'vue';
axios.defaults.timeout = 5000;
import {
    clearSession
} from '../utils/storage';
import {
    Message,
    MessageBox
} from 'element-ui';
axios.defaults.withCredentials = true
// 环境的切换
if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = 'https://hwy.328ym.com/athlete/';
} else if (process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = 'https://hwy.328ym.com/athlete/';
}

//http request 拦截器
axios.interceptors.request.use(
    config => {
        return config;
    },
    error => {
        return Promise.reject(error);
    })

//http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.status == 200 || response.code == 200) {
            if (response.data.code === 413) {
                Message({
                    type: 'error',
                    message: '登录失效，请重新登录',
                    duration: 1000,
                    onClose: () => {
                        clearSession('userInfo');
                        window.location.replace('/login');
                        location.reload();
                    }
                });
            }
            if (response.data.code === 500 || response.data.code === 412) {
                Message({
                    type: 'error',
                    message: response.data.msg
                })

                return Promise.reject(response)
            }
            if (response.data.code === 501) {
                MessageBox(response.data.msg, '提示', {
                    confirmButtonText: '确定',
                    type: 'error'
                }).then(() => {}).catch(() => {});
                return Promise.reject(response)
            }
            return response.data;
        } else {
            Message({
                type: 'error',
                message: response.data.msg,
            });
            return Promise.reject(response)
        }
    },
    error => {
        if (error.response.status) {
            switch (error.response.status) {
                case 400:
                    error.message = '请求参数异常';
                    break
                case 403:
                    error.message = '服务器拒绝您的请求';
                    break;
                case 404:
                    error.message = '请求的资源未找到';
                    break;
                case 413:
                    error.message = "登录失效，请重新登录";
                    window.location.replace('/login');
                    location.reload();
                    break;
                case 502:
                    error.message = '服务器异常，请稍后重试！';
                    break;
                default:
                    error.message = '请求失败，请联系技术人员';
            }
        }
        Message({
            type: 'error',
            message: error.message

        });
        return Promise.reject(error)
    })



/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params) {
    const CancelToken = axios.CancelToken;
    return new Promise((resolve, reject) => {
        axios.get(url, {
                params: params,
                cancelToken: new CancelToken(function executor(c) {
                    Vue.$httpRequestList.push(c)
                })
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data) {
    const CancelToken = axios.CancelToken;
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(data), {
                cancelToken: new CancelToken(function executor(c) {
                    Vue.$httpRequestList.push(c)
                })
            })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err);
            })
    })
}